import { Component, OnInit } from '@angular/core';

const REWARDS_PDF_URLS: Record<string, string> = {
    English: 'https://sellerrewards-datahandler.cisco.com/shared/files/seller-rewards.pdf',
    Korean: 'https://sellerrewards-datahandler.cisco.com/shared/files/korean-seller-rewards.pdf',
    Japanese: 'https://www.cisco.com/c/dam/en/us/products/se/2020/1/Collateral/Jap-seller-rewards.pdf'
};

@Component({
    selector: 'cisco-steer-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    rewardsPdfUrl: string = REWARDS_PDF_URLS.English;

    ngOnInit(): void {
        const lang = localStorage.getItem('selectedLanguage') || 'English';
        this.rewardsPdfUrl = REWARDS_PDF_URLS[lang] || REWARDS_PDF_URLS.English;
    }
}
